/* Oberson — Minuterie du bloc promo (text_promo)
 * Fichier : assets/promo-countdown.js
 * Gère tous les éléments [data-promo-countdown] de la page.
 * La date de fin est saisie en heure de Montréal (America/Toronto), DST géré automatiquement.
 */
(function () {
  if (window.PromoCountdown) return;

  var DEFAULT_TZ = 'America/Toronto';
  var HOUR = 3600000;
  var URGENT_MS = 3 * HOUR; // < 3 h : style « urgent »
  var FINAL_MS = 1 * HOUR;  // < 1 h : style « dernière chance »

  var I18N = {
    fr: { d: 'jour', ds: 'jours', h: 'heure', hs: 'heures', m: 'minute', ms: 'minutes', left: 'Il reste' },
    en: { d: 'day', ds: 'days', h: 'hour', hs: 'hours', m: 'minute', ms: 'minutes', left: 'Time left:' }
  };

  // Décalage (ms) entre l'heure locale du fuseau et UTC à un instant donné
  function tzOffset(ts, tz) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz, hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date(ts));
    var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return +parts[i].value; return 0; };
    return Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second')) - ts;
  }

  // "2026-10-12 23:59" (heure de Montréal) -> timestamp UTC en ms
  function parseEnd(el) {
    if (el.dataset.endTs) return +el.dataset.endTs; // utile pour les tests
    var str = (el.dataset.end || '').trim();
    var m = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2})[:h](\d{2}))?$/i);
    if (!m) return NaN;
    var hasTime = m[4] != null;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], hasTime ? +m[4] : 23, hasTime ? +m[5] : 59, hasTime ? 0 : 59);
    var tz = el.dataset.tz || DEFAULT_TZ;
    var off = tzOffset(guess, tz);
    var ts = guess - off;
    var off2 = tzOffset(ts, tz); // correction aux changements d'heure
    return off2 === off ? ts : guess - off2;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function setNum(node, val) {
    if (!node || node.textContent === val) return;
    node.textContent = val;
    node.classList.remove('is-tick');
    void node.offsetWidth; // relance l'animation
    node.classList.add('is-tick');
  }

  function Countdown(el) {
    this.el = el;
    this.promo = el.closest('[data-promo-block]') || el.parentElement;
    this.hideOnEnd = el.dataset.hideOnEnd === 'true';
    this.windowMs = (parseFloat(el.dataset.showWithin) || 0) * HOUR;
    this.t = I18N[el.dataset.locale] || I18N.fr;
    this.labelNode = el.querySelector('[data-label]');
    this.labels = {
      normal: el.dataset.labelNormal || '',
      urgent: el.dataset.labelUrgent || el.dataset.labelNormal || '',
      final: el.dataset.labelFinal || el.dataset.labelUrgent || ''
    };
    this.nums = {
      d: el.querySelector('[data-num="d"]'),
      h: el.querySelector('[data-num="h"]'),
      m: el.querySelector('[data-num="m"]'),
      s: el.querySelector('[data-num="s"]')
    };
    this.dayGroup = el.querySelectorAll('[data-day]');
    this.bar = el.querySelector('[data-bar]');
    this.sr = el.querySelector('[data-sr]');
    this.reload();
  }

  Countdown.prototype.reload = function () {
    this.end = parseEnd(this.el);
    this.lastSr = '';
    this.done = false;
    if (this.promo && this.promo.dataset.cdHidden) {
      this.promo.style.display = '';
      delete this.promo.dataset.cdHidden;
    }
    if (isNaN(this.end)) {
      console.warn('[promo-countdown] Date de fin invalide :', this.el.dataset.end, '— format attendu AAAA-MM-JJ HH:MM');
      this.el.hidden = true;
      this.done = true;
      return;
    }
    this.tick();
  };

  Countdown.prototype.finish = function () {
    this.done = true;
    this.el.hidden = true;
    if (this.hideOnEnd && this.promo) {
      this.promo.style.display = 'none';
      this.promo.dataset.cdHidden = '1';
    }
  };

  Countdown.prototype.tick = function () {
    if (this.done) return;
    var left = this.end - Date.now();
    if (left <= 0) return this.finish();

    if (this.windowMs && left > this.windowMs) { this.el.hidden = true; return; }
    this.el.hidden = false;

    var total = Math.floor(left / 1000);
    var d = Math.floor(total / 86400);
    var h = Math.floor((total % 86400) / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;

    for (var i = 0; i < this.dayGroup.length; i++) this.dayGroup[i].hidden = d === 0;
    setNum(this.nums.d, pad(d));
    setNum(this.nums.h, pad(h));
    setNum(this.nums.m, pad(m));
    setNum(this.nums.s, pad(s));

    var state = left < FINAL_MS ? 'final' : left < URGENT_MS ? 'urgent' : 'normal';
    if (this.el.dataset.state !== state) {
      this.el.dataset.state = state;
      if (this.labelNode && this.labels[state]) this.labelNode.textContent = this.labels[state];
    }

    if (this.bar && this.windowMs) {
      this.bar.style.transform = 'scaleX(' + Math.max(0, Math.min(1, left / this.windowMs)).toFixed(4) + ')';
    }

    // Lecteurs d'écran : mise à jour à la minute seulement
    if (this.sr) {
      var t = this.t, bits = [];
      if (d) bits.push(d + ' ' + (d > 1 ? t.ds : t.d));
      if (h || d) bits.push(h + ' ' + (h > 1 ? t.hs : t.h));
      bits.push(m + ' ' + (m > 1 ? t.ms : t.m));
      var txt = t.left + ' ' + bits.join(' ');
      if (txt !== this.lastSr) { this.sr.textContent = txt; this.lastSr = txt; }
    }
  };

  var instances = [];

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-promo-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el._cd) { el._cd.reload(); continue; }
      el._cd = new Countdown(el);
      instances.push(el._cd);
    }
  }

  function tickAll() {
    instances = instances.filter(function (c) { return document.contains(c.el); });
    for (var i = 0; i < instances.length; i++) instances[i].tick();
  }

  // Aligné sur la seconde pour un défilement régulier
  setTimeout(function () { tickAll(); setInterval(tickAll, 1000); }, 1000 - (Date.now() % 1000));
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tickAll(); });

  // Éditeur de thème Shopify
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { init(e.target); });

  // Le thème injecte le contenu de product-main plus tard (<lazy-resources>) et l'éditeur
  // re-rend le bloc à chaque changement : on surveille l'arrivée de nouvelles minuteries.
  var pending = false;
  var observer = new MutationObserver(function (mutations) {
    if (pending) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('[data-promo-countdown]') || n.querySelector('[data-promo-countdown]'))) {
          pending = true;
          requestAnimationFrame(function () { pending = false; init(); });
          return;
        }
      }
    }
  });

  window.PromoCountdown = { init: init };

  function start() {
    init();
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();